import Vue from "vue";

const getDefaultState = () => {
  return {
    Activites: [],
    //field: "name",
    //whereField: "role",
    //whereValue: "superviseur",
    collection: "activites",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.Activites = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  async GetAll({ commit, dispatch }) {
    // start requête
    commit("RESET_STATE");
    commit("SET_LISTE", []);
    commit("Loading/START_BUSY_STATE", "Activites GetAll", { root: true });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.Activites.collection)
      .orderBy("ll_parcours", "asc")
      .get()
      .then((snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "Activites.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "Activites.store.js", {
            root: true,
          });
        }
      );
  },
};

const getters = {
  Activites: (state) => {
    return state.Activites;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
